import { Zap, MessageCircle, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/constants";

const DISCORD_INVITE = "https://discord.gg/R5hEsssQgd";
const CONTACT_EMAIL = "management@flowtweaks.com";

export const Footer = () => (
  <footer className="relative border-t border-white/5 bg-[#040404] pt-16 pb-10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <Zap className="w-5 h-5 text-orange-500 fill-orange-500" />
            <span
              className="font-black tracking-[0.18em] uppercase"
              style={{ fontFamily: "'Orbitron', sans-serif" }}
            >
              {BRAND.name}
            </span>
          </div>
          <p className="mt-4 text-zinc-500 max-w-sm leading-relaxed text-sm">
            Pro-level performance optimization for PC and console.
            Built for ranked grinders, content creators, and anyone who refuses
            to lose a fight to a bad frame.
          </p>
          <p className="mt-6 text-orange-500 font-black tracking-[0.3em] uppercase text-xs">
            {BRAND.slogan}
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="text-[11px] tracking-[0.3em] uppercase text-zinc-500 font-bold mb-4">
            Explore
          </div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#pricing" className="text-zinc-300 hover:text-orange-500 transition-colors">Pricing</a></li>
            <li><a href="/#free-scan" className="text-zinc-300 hover:text-orange-500 transition-colors">Free Scan</a></li>
            <li><a href="/#faq" className="text-zinc-300 hover:text-orange-500 transition-colors">FAQ</a></li>
            <li><Link to="/documentation" className="text-zinc-300 hover:text-orange-500 transition-colors">Docs</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-[11px] tracking-[0.3em] uppercase text-zinc-500 font-bold mb-4">
            Company
          </div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/referral" className="text-zinc-300 hover:text-orange-500 transition-colors">Referrals</Link></li>
            <li><Link to="/terms" className="text-zinc-300 hover:text-orange-500 transition-colors">Terms</Link></li>
            <li><Link to="/privacy" className="text-zinc-300 hover:text-orange-500 transition-colors">Privacy</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] tracking-[0.3em] uppercase text-zinc-500 font-bold mb-4">
            Contact
          </div>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="inline-flex items-center gap-2 text-zinc-300 hover:text-orange-500 transition-colors break-all"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4 shrink-0" />
                {CONTACT_EMAIL}
              </a>
            </li>
            <li>
              <a
                href={DISCORD_INVITE}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-zinc-300 hover:text-orange-500 transition-colors"
                data-testid="footer-social-discord"
              >
                <MessageCircle className="w-4 h-4 shrink-0" />
                Discord support
              </a>
            </li>
          </ul>
          <p className="mt-5 text-xs leading-relaxed text-zinc-600">
            Flow Tweaks
            <br />
            A sole proprietorship
            <br />
            Missouri, United States
          </p>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <span className="text-xs tracking-widest uppercase text-zinc-600">
          © {new Date().getFullYear()} Flow Tweaks. All rights reserved.
        </span>
        <span className="text-[10px] tracking-[0.3em] uppercase text-zinc-700">
          Not affiliated with any game publisher.
        </span>
      </div>
    </div>
  </footer>
);
